export function cleanPlatformName(name) {
    if (name == null)
        return null;
    return name
        .replace(/<br\s*\/?>/gi, ' — ')
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
